import { SimpleModal } from '@/app/components/Modal';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { FiAlertCircle } from 'react-icons/fi';
import { Button } from '@/components/ui/button';

export default function CpfConfirmationModal({ showModal, setShowModal, currentUser }) {
  const client = useClient();

  const handleSubmit = async () => {
    const payload = {
      'user-detail-attributes': {
        id: currentUser?.userDetail?.id,
        'cpf-verified': true
      }
    };

    const { error } = await client.mutate(`users/${currentUser.id}`, payload, { method: 'PUT' });
    if (error) {
      toast.error('Erro ao atualizar os dados cadastrais');
      return;
    } else {
      setShowModal(false);
    }
  };

  const cpfFormatted = currentUser.cpfCnpj ? currentUser.cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '000.000.000-00';

  return (
    <SimpleModal
      contentClassName="simple-modal active"
      show={showModal}
      onClose={() => setShowModal(false)}
      hideCloseButton
      closeOnOverlayClick={false}
    >
      <div style={{ width: '100%' }}>
        <h4 className="text-center text-2xl">Olá, Aluno(a) do Mais Formação!</h4>
        <p className="mb-0 text-center text-primary-dark">Por favor, verifique se seus dados cadastrais estão corretos:</p>

        <div className="my-6 rounded-2xl !border border-solid !border-neutral-lightest bg-[#FAFAFA] p-4 pl-8">
          <span>Seu CPF:</span>
          <h5 className="mb-0 text-xl font-bold text-primary">{cpfFormatted}</h5>
        </div>

        <div className="mb-6 flex items-center gap-3 p-3">
          <FiAlertCircle className="rounded-full bg-[#FDB462] p-1 text-4xl font-bold text-white" />
          <p className="mb-0 text-primary-dark">
            <b className="text-primary-dark">Atenção:</b> Caso identifique alguma inconsistência, entre em contato com a <b>Gestão da sua Escola</b> para solicitar a atualização.
          </p>
        </div>
        <p className="mt-4 text-primary-dark">Para concluir, basta clicar no botão abaixo.</p>

        <Button
          fullWidth
          onClick={handleSubmit}
        >
          OK!
        </Button>
      </div>
    </SimpleModal>
  );
}
